import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
    GET_DOWNLOAD_3RDPTY_TEMPLATE,
    GET_DOWNLOAD_MF_TEMPLATE,
    GET_DOWNLOAD_ND_TEMPLATE,
    GET_UPLOAD_3RDPTY_TEMPLATE,
    GET_UPLOAD_MF_TEMPLATE,
    GET_UPLOAD_ND_TEMPLATE
} from '@shared-models/common.models';
import {BadgeRequestCategoryEnum} from '@ui-app/models/common.models';


@Injectable({
    providedIn: 'root'
})
export class BulkVisitorUploadService {
    constructor(
        private httpClient: HttpClient,
        @Optional() @Inject(GET_DOWNLOAD_ND_TEMPLATE) private downloadNonDeloitteTemplate: string,
        @Optional() @Inject(GET_DOWNLOAD_MF_TEMPLATE) private downloadMemberFirmTemplate: string,
        @Optional() @Inject(GET_DOWNLOAD_3RDPTY_TEMPLATE) private downloadContractorTemplate: string,
        @Optional() @Inject(GET_UPLOAD_ND_TEMPLATE) private uploadNonDeloitteTemplate: string,
        @Optional() @Inject(GET_UPLOAD_MF_TEMPLATE) private uploadMemberFirmTemplate: string,
        @Optional() @Inject(GET_UPLOAD_3RDPTY_TEMPLATE) private uploadContractorTemplate: string,
    ) {
    }


    downloadVisitorBulkTemplate(requestCategory: BadgeRequestCategoryEnum, isExtension: boolean = false): Observable<any> {
        let url: string;
        switch (requestCategory) {
            case BadgeRequestCategoryEnum.NonDeloitte:
                url = this.downloadNonDeloitteTemplate;
                break;
            case BadgeRequestCategoryEnum.MemberFirm:
                url = this.downloadMemberFirmTemplate;
                break;
            case BadgeRequestCategoryEnum.ThirdPartyContractor:
                url = this.downloadContractorTemplate + (isExtension ? '/true' : '/false');
                break;
            default:
                url = this.downloadContractorTemplate;
                break;
        }
        return this.httpClient.get<unknown>(url, {
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }

    uploadVisitorFile(requestCategory: BadgeRequestCategoryEnum, file: FormData,isExtension: boolean = false): Observable<unknown> {
        switch (requestCategory) {
            case BadgeRequestCategoryEnum.NonDeloitte:
                return this.httpClient.post<unknown>(this.uploadNonDeloitteTemplate, file);
            case BadgeRequestCategoryEnum.MemberFirm:
                return this.httpClient.post<unknown>(this.uploadMemberFirmTemplate, file);
            case BadgeRequestCategoryEnum.ThirdPartyContractor:
                return this.httpClient.post<unknown>(this.uploadContractorTemplate + (isExtension ? '/true' : '/false'), file);
        }
    }
}
